// /src/hooks/useTagHouseFallback.js
// The R4 house fallback image URL (docs/briefs/2026-08-11-image-layer-build.md §5), for
// render surfaces showing an event whose cover_image_url is still NULL (predates the
// matcher, or genuinely has no tags). One module-scope cached fetch shared by every card
// on a page — many EventsGrid/EventsColumn cards can mount at once, and this value never
// changes mid-session, so there is no reason for each card to fetch platform_settings
// independently. Returns null while loading/on failure; every call site keeps rendering
// its own existing placeholder until this resolves, so there is no new "flash to blank".

import { useState, useEffect } from 'react';
import { eventService } from '../data/dataService';

let cachedPromise = null;

function fetchOnce() {
  if (!cachedPromise) {
    cachedPromise = eventService.getTagHouseFallbackImageUrl();
  }
  return cachedPromise;
}

export function useTagHouseFallback() {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchOnce().then(value => {
      if (!cancelled) setUrl(value);
    });
    return () => { cancelled = true; };
  }, []);

  return url;
}
